import createIncidentData from '../redux/incidents/mock';
import { isTestEnvironment } from '../util/environment';

export default function () {
  if (isTestEnvironment()) {
    this.post('/api/v1/incidents', this.passthrough);
    return;
  }

  this.post('/api/v1/incidents', (params) => {
    const { incident } = JSON.parse(params.requestBody);
    const responseStatus = 201;
    const responseHeaders = { 'Content-Type': 'application/json' };
    const responseBody = createIncidentData(incident);

    return [responseStatus, responseHeaders, JSON.stringify(responseBody)];
  }, 3000);
}
